import { useSelector } from 'react-redux'

const useLocale = () => {
    const keys = useSelector((state) => state.localeStore.keys)
    return keys
}

export default useLocale
